var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0277 2.3999C6.31385 2.3999 3.29562 5.4136 3.29562 9.12189V12.3597C3.29562 13.0431 3.00389 14.085 2.65607 14.6675L1.36574 16.8074C0.569107 18.1294 1.1189 19.597 2.57752 20.0899C7.41343 21.7032 12.6308 21.7032 17.4667 20.0899C18.8244 19.6418 19.4191 18.0397 18.6785 16.8074L17.3882 14.6675C17.0516 14.085 16.7599 13.0431 16.7599 12.3597V9.12189C16.7599 5.4248 13.7304 2.3999 10.0277 2.3999Z",
    stroke: "#11052C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 3.3C11.4984 3.17143 11.187 3.07143 10.866 3.01429C9.9319 2.84286 9.03677 2.94286 8.20001 3.3C8.48217 2.24286 9.18272 1.5 10 1.5C10.8173 1.5 11.5178 2.24286 11.8 3.3Z",
    stroke: "#11052C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 20.3999C13.6 22.3799 11.98 23.9999 9.99999 23.9999C9.01599 23.9999 8.10399 23.5919 7.45599 22.9439C6.80799 22.2959 6.39999 21.3839 6.39999 20.3999",
    stroke: "#11052C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.3467e66c8ab1601df63853c6998d4ba1.svg";
export { ForwardRef as ReactComponent };